import slideManifest from '@digital-twins/slide-schemas/generated/slide-manifest.json'

interface SlideManifestAliases {
  aliases?: {
    validation?: Record<string, string>
    limits?: Record<string, string>
  }
}

const manifestAliases = (slideManifest as SlideManifestAliases).aliases ?? {}

const SLIDE_LIMIT_SCHEMA_OVERRIDES: Record<string, string> =
  manifestAliases.limits ?? {}

export function normalizeSlideTypeForLimits(slideType: string): string {
  return SLIDE_LIMIT_SCHEMA_OVERRIDES[slideType] ?? slideType
}
